import React from 'react';
import { useSelector } from 'react-redux';
import Truncate from 'react-truncate';

import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  CoreLink,
} from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  VACANCY_TYPES,
} from '../../../../config/constants';

import './style.scss';

const NodeVacancyTeaser = ({ entity }) => {
  const {
    t,
  } = useTranslation();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  const title = entity.getIn(['title', 0, 'value'], '');
  const bodyStripped = entity.getIn(['body', 0, 'processed'], '').replace(/(<([^>]+)>)/ig, '');
  const summary = entity.getIn(['body', 0, 'summary'], '');
  const hero = entity.getIn(['field_image', 0, 'styles'], '');
  const workingHours = entity.getIn(['field_working_hours', 0, 'entity', 'name', 0, 'value'], '');
  const location = entity.getIn(['field_location', 0, 'entity', 'name', 0, 'value'], '');
  const vacancyType = entity.getIn(['field_vacancy_type', 'entity', 'field_system_name', 0, 'value'], '');
  const isVolunteerType = vacancyType === VACANCY_TYPES.Volunteer;
  const url = entity.getIn(['paths', currentLanguage], '/');

  return (
    <article className="NodeVacancyTeaser">
      <CoreLink to={url}>
        <div className="NodeVacancyTeaser__imageWrapper">
          <Image
            lazyload
            includeWebP
            alt={title}
            src={{
              [SCREEN_MOBILE]: hero.getIn(['crop_4_3']),
              [SCREEN_TABLET]: hero.getIn(['crop_4_3']),
              [SCREEN_NORMAL]: hero.getIn(['crop_4_3']),
            }}
          />
          {/* TODO this is incomplete */}
          {isVolunteerType && <div className="NodeVacancyTeaser__imageWrapper__type">{t('vacancy.type_volunteer_work')}</div>}
        </div>


        <div className="NodeVacancyTeaser__textWrapper">
          <h3>
            {title}
          </h3>

          {location && (
            <div className="small"><i className="icon icon-pin2" />
              {location}
            </div>
          )}
          {workingHours && (
            <div className="small time"><i className="icon icon-time" />
              {workingHours}
            </div>
          )}
          {bodyStripped && (
            <div className="NodeVacancyTeaser__textWrapper__body">
              <Truncate lines={3} ellipsis="...">
                <WysiwygField
                  property="schema:text"
                  html={(summary !== '' ? summary : bodyStripped)}
                />
              </Truncate>
            </div>
          )}

          <div className="NodeVacancyTeaser__CTA">{isVolunteerType ? t('vacancy.show_volunteer_offer') : t('vacancy.show_vacancy')} <i className="icon icon-arrow-right" /></div>

        </div>
      </CoreLink>
    </article>
  );
};

export default NodeVacancyTeaser;
